// The tab bar at the bottom: Home, Budget, Recurring, Settings. An Account screen
// belongs to Home, so Home stays lit there. Hidden on the login screen.

const ICON = (d: string) =>
  `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;

const TABS: { route: string; label: string; icon: string }[] = [
  { route: 'home', label: 'Home', icon: ICON('<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h5v-6h4v6h5V9.5"/>') },
  { route: 'budget', label: 'Budget', icon: ICON('<line x1="3" y1="20.5" x2="21" y2="20.5"/><rect x="4.5" y="11" width="4" height="7" rx="1"/><rect x="10" y="5" width="4" height="13" rx="1"/><rect x="15.5" y="13" width="4" height="5" rx="1"/>') },
  { route: 'recurring', label: 'Recurring', icon: ICON('<path d="M17 2.5 20.5 6 17 9.5"/><path d="M3.5 11V9.5A3.5 3.5 0 0 1 7 6h13.5"/><path d="M7 21.5 3.5 18 7 14.5"/><path d="M20.5 13v1.5A3.5 3.5 0 0 1 17 18H3.5"/>') },
  { route: 'settings', label: 'Settings', icon: ICON('<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>') },
];

export function createTabBar(): HTMLElement {
  const nav = document.createElement('nav');
  nav.className = 'tabbar';
  nav.setAttribute('aria-label', 'Main');
  const buttons = TABS.map(t => {
    const b = document.createElement('button');
    b.className = 'tab';
    b.dataset.route = t.route;
    b.innerHTML = `<span class="tab-icon">${t.icon}</span><span class="tab-label">${t.label}</span>`;
    b.addEventListener('click', () => { location.hash = '#' + t.route; });
    nav.appendChild(b);
    return b;
  });

  const update = (route: string) => {
    nav.classList.toggle('hidden', route === 'login');
    const active = route === 'account' ? 'home' : route;
    for (const b of buttons) {
      const on = b.dataset.route === active;
      b.classList.toggle('on', on);
      if (on) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current');
    }
  };
  window.addEventListener('routechange', (e: Event) => update((e as CustomEvent<{ route: string }>).detail.route));
  update((location.hash.slice(1) || 'home').split('?')[0]);
  return nav;
}
